import { Box } from '@mui/material';
import { CustomerDetailRoutes } from 'routing/customer-detail-routes';
import { ProvideContractUploadState } from 'shared/contexts/contract-inventory-form-context';
import { useUserPermissions } from 'shared/hooks';
import { CustomerDetailsNavigationHeader } from './customer-details-navigation-header';
import { useQueryContracts } from 'shared/queries';
import { useHistory, useParams } from 'react-router-dom';
import { ContractRouteParams } from 'shared/types';
import { useEffect } from 'react';
import { compareDates } from 'shared/utility';

export function CustomerDetails() {
  const userPermissions = useUserPermissions();
  const hasControllerPermission = userPermissions.includes('abg-retail.controller');
  const { masterCustomer, abgBrand } = useParams<ContractRouteParams>();
  const { contracts, isLoading } = useQueryContracts({ brand: abgBrand, customer: masterCustomer });
  const history = useHistory();

  useEffect(() => {
    if (hasControllerPermission && contracts &&
      contracts
        .filter(c => c.approvalStatus === 'Approved'
          && (!c.endDate || compareDates(new Date(c.endDate), new Date()) !== 1)).length > 0) {
      const firstApprovedContract = contracts.filter(c => c.approvalStatus === 'Approved'
        && (!c.endDate || compareDates(new Date(c.endDate), new Date()) !== 1))[0];
      history.push(`/customer-management/customer-details/${masterCustomer}/${abgBrand}/viewContract/${firstApprovedContract.id}`);
    }
  }, [hasControllerPermission, contracts, abgBrand, history, masterCustomer]);

  return (
    <>
      {!hasControllerPermission && (
        <>
          <CustomerDetailsNavigationHeader />
        </>
      )}
      <ProvideContractUploadState>
        <Box padding={2} marginBottom='30px'>
          <CustomerDetailRoutes isLoading={isLoading} />
        </Box>
      </ProvideContractUploadState>
    </>
  );
}
